// slide in animation
/*
function reveal() {
  var windowHeight = $(window).height();
  var reveals = $(".reveal");
  var elementVisibleOffset = 15;
  var scrollTop = $(window).scrollTop();

  reveals.each(function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    if (elementTop < (scrollTop + windowHeight - elementVisibleOffset) && elementBottom > scrollTop && !$(this).hasClass("active")) {
      $(this).addClass("active");
    }
  });
}

function throttle(callback, delay) {
  var previousCall = new Date().getTime();
  return function() {
    var time = new Date().getTime();
    if ((time - previousCall) >= delay) {
      previousCall = time;
      callback.apply(null, arguments);
    }
  };
}

$(document).ready(function() {
  reveal();
  $(window).scroll(throttle(reveal, 30));
});
*/


// open external links in blank
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

//lazyload bg images
$(document).ready(function() {
    function lazyLoadBackgrounds() {
        $('.bg-element').each(function() {
            var element = $(this);
            var bgSrc = element.data('bg-src');
            var offset = element.offset().top;
            var windowHeight = $(window).height();
            var scrollTop = $(window).scrollTop();
            if (offset < (scrollTop + windowHeight)) {
                element.css('background-image', 'url(' + bgSrc + ')');
                element.removeAttr('data-bg-src');
            }
        });
    }
    $(window).on('load scroll', function() {
        lazyLoadBackgrounds();
    });
});

// helpfeel lazyload
function cargarHelpFeel() {
    var helpfeelDiv = document.getElementById('helpfeel-launch');
    if (helpfeelDiv) {
        function cargarScript() {
            var scriptHelpFeel = document.createElement('script');
            scriptHelpFeel.src = 'https://helpfeel.com/projects/js/helpfeel-element.js';
            document.body.appendChild(scriptHelpFeel);
            helpfeelDiv.removeEventListener('click', cargarScript);
        }

        helpfeelDiv.addEventListener('click', cargarScript);
    }
}
window.addEventListener('load', cargarHelpFeel);